<template>
  <div class="col-lg-12">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title">게시판 관리
        </h5>
        <div class="sub_title">본사공지용 게시판 관리(지사 및 학원용을 추후 개발예정)</div>
 <query-grid :config="config" ref="qg">
                    <template #actions>
                      <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg" @click="goCreating()">게시판 생성</button>
          </template>
          <template #items="props">
<tr v-for="article in props.records" v-bind:key="article.id">
              <td style="height:48px;">{{ article.id }}</td>
              <td>{{ article.name }}</td>
                <td>
                  <router-link :to="'/boards/' + article.name + '/articles'">{{ article.title }}</router-link>
                </td>
                <td>{{ article.descriptions }}</td>
                <td><Admin :admin="article.b1" /></td>
                <td>{{ article.created_at}}</td>
            </tr>
          </template>
        </query-grid>

<!-- Large modal -->

<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">게시판 생성</h5>

            </div>
            <div class="modal-body">
              <table class="table">
                  <tbody>
                    <tr v-if="this.$root.guiPerm == 'ROOT'">
                      <td class="th_bg">게시판코드(영문, 숫자, _만 사용 가능)<br>선택(미입력시 자동생성)</td>
                      <td ><input type="text" class="hidtype" style="width:140px;" v-model="selBoard.name"/></td>
                      <td class="th_bg">게시판명</td>
                      <td><input type="text" class="hidtype" style="width:140px;" v-model="selBoard.title"/></td>
                    </tr>
                    <tr>
                      <td class="th_bg">게시판 설명</td>
                      <td v-if="!(this.$root.businesses.length == 1 && this.$root.businesses[0].type == 'ENTERPRISE')"><input type="text" class="hidtype" style="width:140px;" v-model="selBoard.descriptions"/></td>
                      <td class="th_bg" v-if="!(this.$root.businesses.length == 1 && this.$root.businesses[0].type == 'ENTERPRISE')">소속학원</td>
                      <td v-if="!(this.$root.businesses.length == 1 && this.$root.businesses[0].type == 'ENTERPRISE')" >
                         <tree-btn :tree="this.$refs.manageRange" v-if="this.mounted" />
                         </td>
                    </tr>

                    <tr>
                      <td class="th_bg">글읽기 권한</td>
                      <td>
                        <select class="hidtype" v-model="selBoard.readPerms">
                          <option value="0">본사</option>
                          <option value="1">본부</option>
                          <option value="2">학원</option>
                          <option value="3">강사</option>
                          <option value="4">학생</option>
                          <option value="5">비로그인</option>
                        </select>
                      </td>
                      <td class="th_bg">글쓰기 권한</td>
                      <td>

                        <select class="hidtype" v-model="selBoard.writePerms">
                          <option value="0">본사</option>
                          <option value="1">본부</option>
                          <option value="2">학원</option>
                          <option value="3">강사</option>
                          <option value="4">학생</option>
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <td class="th_bg">댓글 권한</td>
                      <td>

                        <select class="hidtype" v-model="selBoard.commentPerms">
                          <option value="0">본사</option>
                          <option value="1">본부</option>
                          <option value="2">학원</option>
                          <option value="3">강사</option>
                          <option value="4">학생</option>
                          <option value="5">비로그인</option>
                        </select>
                      </td>
                      <td> </td>
                      <td> </td>
                    </tr>

                  </tbody>
                </table>

            </div>
            <div class="modal-footer flex_center">
              <button type="button" class="btn btn-primary" @click="doSend()" data-bs-dismiss="modal">등록</button>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>

            </div>
        </div>
    </div>
</div>


  <Tree :key="$route.path" :tree-data="this.$root.businesses" render-button :callback="selectedBiz" ref="manageRange" :selectable="['ENTERPRISE', 'ROOT']"/>
      </div>
    </div>
  </div>

</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import QueryGrid from "../components/QueryGrid";
import Admin from "../components/detail_pages/Admin";
import axios from "axios";
 import TreeBtn from '../components/treeBtn.vue';
export default {
  name: 'Home',
  components: {
    Tree,
    QueryGrid,
    Admin  ,
        TreeBtn,
  },
  mounted(){
    //this.search();
    this.mounted=true;
  },
  methods: {
          selectedBiz(biz) {
        this.selBiz = biz;
      },
      doSend(){
                // 업데이트일 경우 patch /businesses/번호
        // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
        var data = {
            ...this.selBoard,
            business: this.selBiz.id || this.selBoard.business || this.$root.businesses[0].id,
          };
        axios({
          method: this.creating ? "post" : "patch",
          url: '/boards' + (!this.creating ? "/" + this.selBoard.id : ""),
          data: data
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '처리할 수 없습니다 ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.$refs.qg.search()
            $.notify({
              // options
              message: '완료되었습니다.'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });


          }


        })

      },
      goCreating(){
        this.selBoard = {
        id: null,
        name: null,
        title: null,
        descriptions: null,
        readPerms: null,
        writePerms: null,
        commentPerms: null
        }
        this.creating = true;
      }
  },
  data(){
    return {
      selBiz: null,
      mounted: false,
      config: {
    "name": "게시판 리스트",
    "req_endpoint": '/boards',
    "default_limit": 20,
    "search_fields": [
              {
            "id": "businesses",
            "name": "소유학원",
            "type": "business" // business, date, datetime,
        },
        {
            "id": "date_filter",
            "name": "날짜검색",
            "type": "date",
            "filter_type": {
                "created_at": "생성일",
                "updated_at": "수정일"
            }
        },
        {
            "id": "search",
            "name": "키워드검색",
            "type": "text",
            "placeholder": "게시판ID/이름/설명으로 검색"
        },
                {
            "id": "readPerms",
            "name": "읽기권한",
            "type": "switch",
            "filter_type": {
                "0": "본사",
                "1": "본부",
                "2": "학원",
                "3": "강사",
                "4": "학생",
                "5": "비로그인"
            }
        },
                        {
            "id": "writePerms",
            "name": "쓰기권한",
            "type": "switch",
            "filter_type": {
                "0": "본사",
                "1": "본부",
                "2": "학원",
                "3": "강사",
                "4": "학생"
            }
        },
                                {
            "id": "writePerms",
            "name": "댓글권한",
            "type": "switch",
            "filter_type": {
                "0": "본사",
                "1": "본부",
                "2": "학원",
                "3": "강사",
                "4": "학생"
            }
        },
                                {
            "id": "hidden",
            "name": "홈페이지에서 숨김",
            "type": "switch",
            "filter_type": {
                "0": "숨김",
                "1": "표시"
            }
        }
    ],
    "columns": [
        {
            "id": "id",
            "sortable": true,
            "name": "번호",
            "excel_print": v=>{return v.id}
        },
                {
            "id": "name",
            "sortable": true,
            "name": "게시판명(영문)",
            "excel_print": v=>{return v.name}
        },
        {
            "id": "title",
            "sortable": true,
            "name": "게시판설명(한글)",
            "excel_print": v=>{return v.title}
        },
                {
            "id": "descriptions",
            "sortable": true,
            "name": "설명",
            "excel_print": v=>{return v.descriptions}
        },
                        {
            "id": "businesses",
            "sortable": true,
            "name": "소속학원",
            "excel_print": v=>{return v.b1.name}
        },
                {
            "id": "created_at",
            "sortable": true,
            "name": "등록일",
            "excel_print": v=>{return v.created_at}
        }
    ]
},
selBoard: {
id: null,
name: null,
title: null,
descriptions: null,
readPerms: null,
writePerms: null,
commentPerms: null
},
selBiz: {

},
creating: false,
      records: []
    }
  }
}
</script>
